import sanitizeHtml from "sanitize-html";

const ICON_BASE_PATH = "/images/medicine/icon/";

/**
 * バックエンドが返す <icon>ic_xxx</icon> 中間形式を
 * sanitized HTML（<img> タグ）に変換する
 */
export function renderMedicineHtml(text: string): string {
  if (!text) return "";

  const html = text.replace(
    /<icon>([\w_\\-]+)<\/icon>/g,
    (_, iconName) =>
      `<img src="${ICON_BASE_PATH}${iconName}.svg" class="medicine-icon" alt="${iconName}">`
  );

  return sanitizeHtml(html, {
    allowedTags: ["img", "br", "em", "sup", "sub", "span", "a"],
    allowedAttributes: {
      img: ["src", "class", "alt"],
      span: ["class"],
      a: ["data-product-id", "class", "href"]
    },
    allowedSchemes: [],
    allowedSchemesAppliedToAttributes: [],
    transformTags: {
      img: (tagName, attribs) => {
        const src = attribs.src || "";
        if (!src.startsWith(ICON_BASE_PATH)) {
          return { tagName: "span", attribs: {} };
        }
        return { tagName, attribs };
      },
      // href は不要なので除去し、data-product-id と class のみ残す
      a: (tagName, attribs) => {
        return {
          tagName,
          attribs: {
            "data-product-id": attribs["data-product-id"] || "",
            class: attribs.class || ""
          }
        };
      }
    }
  });
}
